module.exports = __webpack_public_path__ + "img/0.1e349bf1.jpg";